import zbTransfer from './zb-transfer.vue'

export default zbTransfer
